import { SwalMessage, ToastMessage } from '../Tools'


var Questions = function () {

    var handle = function (form) {

        // sipariş seçince ürünleri getirme
        $(form).on('change', '[name="order_id"]', function (event) {
            event.preventDefault();

            if(this.value == '' || !this.value){
                return;
            }

            let id = this.value

            // console.log(id);
            $.ajax({
                url: apiUrl + '/GetOrderById',
                type: "POST",
                dataType: "json",
                data: {
                    id: id
                },
                async: true,
                error: function error(xhr) {
                    // console.log(xhr)
                    SwalMessage(
                        {
                            type: 'error',
                            text: xhr.responseJSON.text ?? xhr.responseJSON.message,
                            confirmButton: translate.ok_button,
                        },
                        function () {
                            form.querySelector('[data-question-product]').classList.add('d-none')
                        }
                    );

                },
                beforeSend: function () {
                    form.querySelector('[data-question-product]').classList.add('d-none')
                },
                complete: function () {

                },
                success: function success(xhr) {
                    // console.log(xhr)
                    form.querySelector('[data-question-product]').classList.remove('d-none')
                    if (xhr.products) {
                        $(form).find('[name="product_id"]').empty();
                        let products = JSON.parse(xhr.products)
                        products.forEach(product => {
                            var option = document.createElement("option");
                            option.text = product.product_name.product_name;
                            option.value = product.product_id.product_id;
                            form.querySelector('[name="product_id"]').add(option)
                        });
                    }

                }
            });
        })

        // talep gönder
        $(form).on('click', '[data-canvas-save="question"]', function (event) {
            event.preventDefault();


            const form = event.target.closest('form')
            let button = this

            $.ajax({
                url: apiUrl + '/CreateCustomerQuestion',
                type: "POST",
                dataType: "json",
                data: $(form).serialize(),
                async: true,
                error: function error(xhr) {
                    // console.log(xhr)
                    SwalMessage(
                        {
                            type: 'error',
                            text: xhr.responseJSON.text ?? xhr.responseJSON.message,
                            confirmButton: translate.ok_button,
                        },
                        function () {
                            // location.reload();
                        }
                    );
                },
                beforeSend: function () {
                    button.setAttribute('disabled', '');
                },
                complete: function () {
                    button.removeAttribute('disabled');
                },
                success: function success(xhr) {
                    // console.log(xhr)

                    $('#canvasQuestion [data-bs-dismiss="offcanvas"]').click()

                    ToastMessage('0', translate.request_text, xhr.text ?? xhr.message)
                    location.reload();
                }
            });
        })

        // talep iptal
        $(form).on('click', '[data-canvas-close="question"]', function (event) {
            event.preventDefault();
            $('#canvasQuestion [data-bs-dismiss="offcanvas"]').click()
        })

        $(form).find('[name="order_id"]').trigger('change');
    }


    return {
        init: function () {
            var elements = document.querySelectorAll('[data-canvas="question"]');
            elements.forEach(function(element){
                if (element) {
                    handle(element);
                }
            })
        },
    };

}();




$(function () {
    Questions.init();
});